module.exports = __webpack_public_path__ + "static/media/undraw_mobile_login_ikmv.cd823517.svg";